export const StorageService = {
  getBoolean(key: string, fallback = false): boolean {
    if (typeof window === "undefined") return fallback;
    const raw = window.localStorage.getItem(key);
    if (raw === null) return fallback;
    return raw === "true";
  },

  setBoolean(key: string, value: boolean): void {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(key, String(value));
  },

  getString(key: string): string | null {
    if (typeof window === "undefined") return null;
    return window.localStorage.getItem(key);
  },

  setString(key: string, value: string): void {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(key, value);
  },

  removeItem(key: string): void {
    if (typeof window === "undefined") return;
    window.localStorage.removeItem(key);
  },
};
